
import {EventEmitter, Injectable} from '@angular/core';
import {Event, NavigationEnd, Router} from '@angular/router';
import {BehaviorSubject, Subscription} from 'rxjs';
import { MatSidenav } from '@angular/material/sidenav';
import { NavItem } from '../interfaces/nav-item';
import { TabService } from './tab.service';
import { HTTPService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class NavService {
  
  selectItem(item: NavItem, useTab: boolean, router: Router, tabService: TabService, routeName: string, idUser:number) {
    
    if (!item.children || !item.children.length) {

      // ✅ Validação: Determinar URL válida com fallback
      const targetUrl = routeName || item.route || item.id || 'home';
      
      if (!targetUrl || targetUrl.trim() === '') {
        console.error('❌ NavService.selectItem: Item sem route/id válido:', item);
        return; // Não navega se não tiver URL válida
      }

      if ( useTab ){
        
        let i = tabService.tabs.findIndex(x=>{
          return x.url === targetUrl
        });
        
        if ( i >= 0 ){
            tabService.activeTabIndex.next(i);
            setTimeout(()=>{
              this.router.navigate([targetUrl], { skipLocationChange: true });
            },100);
        }else{
          tabService.addTab(item);
          tabService.activeTabIndex.next(tabService.tabs.length+1);
        }
        setTimeout(()=>{
          this.router.navigate([targetUrl], { skipLocationChange: true });
        },100);
        
      }else{
        this.router.navigate([targetUrl], { skipLocationChange: true });
      }
      this.saveLog(item,idUser);
    }

  }

  selectItem2(item: NavItem,  router: Router, tabService: TabService, routeName: string, idUser:number, state:any = null) {
    
    if (!item.children || !item.children.length) {

      // ✅ Validação: Determinar URL válida com fallback
      const targetUrl = routeName || item.route || item.id || 'home';
      
      if (!targetUrl || targetUrl.trim() === '') {
        console.error('❌ NavService.selectItem: Item sem route/id válido:', item);
        return; // Não navega se não tiver URL válida
      }
        
      let i = tabService.tabs.findIndex(x=>{
        return x.url === targetUrl
      });
      
      if ( i >= 0 ){
          tabService.activeTabIndex.next(i);
          setTimeout(()=>{
            this.router.navigate([targetUrl], { skipLocationChange: true, queryParams:state});
          },100);
      }else{
        tabService.addTab(item);
        tabService.activeTabIndex.next(tabService.tabs.length+1);
      }
      setTimeout(()=>{
        this.router.navigate([targetUrl], { skipLocationChange: true , queryParams:state });
      },100);
       
      this.saveLog(item,idUser);
    }

  }

  saveLog(item: NavItem, idUser:number) {
      
    let ob = {
          entityName: 'Mktpmenulog',
          IDUSER: idUser,
          IDMENU: item.nuMenu
      }

      this.http.post(ob,'JsonBrokerServices/save',false,true,false).subscribe();
  }
  


  public appDrawer: MatSidenav;
  public currentUrl = new BehaviorSubject<string>(undefined);
  sub:Subscription;
  public sidenavSmall:boolean = true;

  constructor(private router: Router, private http:HTTPService) {
    this.sub = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl.next(event.urlAfterRedirects);
      }
    });
  }

  ngOnDestroy(){
    if (this.sub!= null ) {this.sub.unsubscribe();}
  }

  public closeNav() {
    this.appDrawer.close();
  }

  public openNav() {
    this.appDrawer.open();
  }

  public setSmall(){
    this.sidenavSmall = true;
  }

  public setBig(){
    this.sidenavSmall = false;
  }
  
}
